<template lang="pug">
  app-modal(
    titulo="Modelo Memorial Descritivo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      div.padding
        span Partindo do marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue pelo lote
        |  ocupado por NOME, com a seguinte distância XXXX m e azimute plano XXX°XX'XX" até o marco XXX-X-XXXX,
        |  de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue pelo lote ocupado por NOME, com a seguinte distância
        |  XXXX m e azimute plano XXX°XX'XX" até o marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste,
        |  segue pelo lote ocupado por NOME, com a seguinte distância XXXX m e azimute plano XXX°XX'XX" até o marco XXX-X-XXXX,
        |  de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue pelo lote ocupado por NOME, com a seguinte distância XXXX m e
        |  azimute plano XXX°XX'XX" até o marco XXX-X-XXXX, de coordenada N = XXXXXXXm e E = XXXXXXXm; deste, segue pelo lote ocupado por NOME,
        |  com a seguinte distância XXXX m e azimute plano XXX°XX'XX" m até o marco XXX-X-XXXX, ponto inicial da descrição deste perímetro.
        |  Todas as coordenadas aqui descritas estão georreferenciadas ao Sistema Geodésico Brasileiro, a partir do marco XXX-X-XXXX, de coordenada
        |  N = XXXXXXXm e E = XXXXXXXm, e encontram-se representadas no Sistema U T M, referenciadas ao Meridiano Central nº 45°00', fuso -23, tendo
        |  como datum o SIRGAS2000. Todos os azimutes e distâncias, área e perímetro foram calculados no plano de projeção U T M.
</template>

<script>
import AppModal from '@/components/AppModal'

export default {

  components: {
    AppModal
  },

  props: {
    width: {
      type: Number,
      default: 900
    }
  }
}

</script>

<style scoped lang="scss">
.padding {
  padding: 10px;
  color: #424242;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/components/AppModalModeloMemorial.vue